export const auth = {
  loginTitle: 'Entrar',
  loginSubtitle: 'Acesse sua conta para continuar.',
  tagline: 'Sua plataforma de backoffice.',
  email: 'E-mail',
  password: 'Senha',
  submit: 'Entrar',
  passwordShow: 'Mostrar senha',
  passwordHide: 'Ocultar senha',
  azureSignIn: 'Entrar com Microsoft',
  orContinueWith: 'ou continue com e-mail',
  invalidCredentials: 'E-mail ou senha inválidos.',
  azureCallbackPending: 'Concluindo login com a Microsoft...',
  azureCallbackFailed: 'Não foi possível concluir o login. Tente novamente.',
  logout: 'Sair',
  avisoEmailNt: {
    titulo: 'Use o seu e-mail da NTConsult',
    texto:
      'Entre com o e-mail @ntconsult.com.br ou @ntconsultcorp.com. Não use o e-mail do cliente onde você atua, mesmo que ele seja da Microsoft.',
    dica: 'Use o e-mail da NTConsult (@ntconsult.com.br ou @ntconsultcorp.com).',
  },
} as const;
